/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import React, { Component } from 'react';
import PropTypes from 'util/PropTypes';
import { EmptyState, Label } from '@ba/ba-ui-carbon-toolkit';
import classNames from 'classnames';

import _ from 'underscore';

import './empty.scss';

class Empty extends Component {

	constructor(props){
		super(props);
		this.changeDetailsTimeout = null;
		this.state = {
			turnOnTimer: false
		};//when turnOnTimer is true, description will change on Timer
	}

	componentWillUnmount() {
		clearTimeout(this.changeDetailsTimeout);
	}

	render() {
		const icon = this.renderIcon();
		const title = this.renderTitle();
		const description = this.renderDescription();
		const emptyState = this._renderEmptyState();

		const alignment = this.props.alignment;
		const styles = {
			'align-items': alignment ? alignment : 'center',
			'text-align': alignment ? alignment : 'center'
		};

		const forwardedProps = _.omit(this.props, 'children', 'icon', 'title', 'description', 'timerInterval', 'alignment', 'type');

		return (
			<div className="explore__empty" {...forwardedProps} style = {styles}>
				<div className={classNames({
					'explore__empty__container': true,
					'explore__empty__container--selectable': this.props.selectable
				})}>
					{icon}
					{emptyState}
					{title}
					{description}
					{this.props.children}
					{this.renderSuggestions(styles)}
				</div>
			</div>
		);
	}

	renderIcon() {
		if (this.props.icon) {
			return (
				<div className="explore__empty__icon">
					{this.props.icon}
				</div>
			);
		}
	}

	_renderEmptyState() {
		if(this.props.type) {
			return (
				// This surrounding div is temporary needed to hide the SVG until https://jsw.ibm.com/browse/BAUICOMMON-691 delivers an updated SVG
				<div data-html2canvas-ignore>
					<EmptyState
						type={this.props.type}
						size={'large'}>
					</EmptyState>
				</div>
			);
		}
	}

	renderTitle() {
		if (this.props.title) {
			return (
				<Label label={this.props.title} className={classNames({
					'explore__empty__title': true,
					'explore__empty__title--selectable': this.props.selectable
				})} />
			);
		}
	}

	/**
	 * If enableTimer is turned on, the description will be automtically chagned to the the alternate description
	 * @return {[type]} [description]
	 */
	renderDescription() {
		if (this.props.description) {
			if(!this.state.turnOnTimer && this.props.enableTimer && this.props.alternateDescription){
				this.changeDetailsTimeout = setTimeout(
					this.turnOnTimer.bind(this)
					,this.props.timerInterval);
			}
			const description = this.state.turnOnTimer ? this.props.alternateDescription: this.props.description;
			return (
				<Label label={description} className={classNames({
					'explore__empty__description': true,
					'explore__empty__description--selectable': this.props.selectable
				})} />
			);
		}
	}

	turnOnTimer(){
		clearTimeout(this.changeDetailsTimeout);
		this.setState({ 'turnOnTimer' : true });
	}

	/*Suggestions information for an error situation*/
	renderSuggestions(styles) {
		if (this.props.suggestions) {
			return (<div className= 'explore__empty__suggestions' style={styles}>{this.props.suggestions}</div>);
		}
		return null;
	}
}

Empty.propTypes = {
	children: PropTypes.any,
	icon: PropTypes.object,
	title: PropTypes.string,
	description: PropTypes.string,
	enableTimer: PropTypes.bool,
	timerInterval: PropTypes.number,
	alternateDescription: PropTypes.string,
	selectable: PropTypes.bool,
	alignment: PropTypes.string,
	suggestions: PropTypes.string,
	type: PropTypes.string
};

Empty.defaultProps = {
	children: [],
	selectable: false,
	enableTimer: false,
	timerInterval: 15,
	alternateDescription: '',
	alignment: '',
	suggestions: '',
	type: ''
};

export default Empty;



// WEBPACK FOOTER //
// ./src/js/components/empty/Empty.js